import { clsx } from 'clsx';
import type { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Builds a className, resolving Tailwind conflicts in favour of the last one.
 *
 * <p>`clsx` handles conditionals; `twMerge` handles the part that catches people
 * out — `clsx('p-2', 'p-4')` yields both classes and which wins depends on their
 * order in the stylesheet, not in the call. Merged, `p-4` wins because it was
 * written last, which is what a caller passing an override expects.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
